import {Col, Row} from "react-bootstrap";

import {useEffect, useState} from "react";
import parse from "html-react-parser";
import Graphs from "../../Reader/FirstTimeSetup/HomeScreens/ReviewHistory/Graphs";
import {useTranslation} from "react-i18next";




const DailyGraph = (props) => {
    const {t} = useTranslation()
    const lang = localStorage.getItem('lang');
    const [image, setImage] = useState(null);
    useEffect(() => {
        setImage(props.step === 1 ? `/translations/${lang}/ProductUse/ReviewHistory/daily_graph_app.jpg` : `/translations/${lang}/ProductUse/ReviewHistory/daily_graph.jpg`)
    }, [lang, props.step])
    useEffect(() => {
        console.log(props.step)

    }, [props.step])
    const dailyGraphShow = parse(t("dailyGraphShow").replace('%CLOCK_IMG%', '<img src="/icons/reader_time.png" />'));
    return (
        <Row>
            <Col>
                <p className={'fw-bold bkg-ligth-grey-2 py-2 px-2'}>{t('whatData')}</p>
                <p className={'bkg-ligth-grey-2 pt-4 mb-0  px-2  h-100'}>
                    {t('dailyGraphData')}
                </p>
            </Col>
            <Col>
                <p className={'fw-bold bkg-ligth-grey-2 py-2 px-2'}>{t('whatDataShow')}</p>
                <p className={' bkg-ligth-grey-2 pt-4 mb-0  px-2 h-100'}>
                    {dailyGraphShow}
                </p>
            </Col>
            <Col>
                <p className={'fw-bold bkg-ligth-grey-2 py-2 px-2'}>{t('example')}</p>
                <p className={' bkg-ligth-grey-2 pt-4 mb-0  px-2 h-100'}>

                    {props.step === 1 ? <img src={image} className={'img-fluid'}/> :

                         <div className={'border-groove'} style={{background: '#fff', borderRadius: '10px'}}>
                             <Graphs grapType={'dailyGraph'} isStatic={true}/>
                         </div>  }

                </p>
            </Col>
        </Row>
    )

}
export default DailyGraph